import { useState } from "react";
import api from "../lib/api";
import { apiError } from "../lib/auth";

const FIELDS = [
  ["company", "Firmanavn", { autoComplete: "organization", maxLength: 120 }],
  ["cvr", "CVR-nummer", { inputMode: "numeric", maxLength: 11, placeholder: "8 cifre" }],
  ["address", "Adresse", { autoComplete: "street-address", maxLength: 160 }],
  ["zip_city", "Postnr. og by", { placeholder: "Fx 6000 Kolding", maxLength: 80 }],
  ["email", "Faktura-e-mail", { type: "email", autoComplete: "email" }],
  ["ean", "EAN-nummer (valgfrit)", { inputMode: "numeric", maxLength: 15 }],
  ["reference", "Reference (valgfrit)", { maxLength: 80, placeholder: "Fx indkøbsnr. eller kontaktperson" }],
];

export default function BillingForm({ initial, pending, onDone, onCancel }) {
  const [v, setV] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, initial?.[k] || ""])));
  const [errors, setErrors] = useState({});
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    setErrors({});
    try {
      const r = await api.post("/billing/start", v);
      onDone(r.data);
    } catch (ex) {
      if (ex.response?.data?.errors) setErrors(ex.response.data.errors);
      else setErr(apiError(ex.response?.data?.detail) || ex.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="bf-form" onSubmit={submit} noValidate data-testid="billing-form">
      {err && <div className="notice error" role="alert" data-testid="billing-form-error">{err}</div>}
      <div className="bf-grid">
        {FIELDS.map(([k, label, props]) => (
          <div className={`field bf-${k}`} key={k}>
            <label htmlFor={`bf-${k}`}>{label}</label>
            <input id={`bf-${k}`} value={v[k]} onChange={(e) => setV((o) => ({ ...o, [k]: e.target.value }))}
              aria-invalid={!!errors[k]} data-testid={`billing-${k}`} {...props} />
            {errors[k] && <div className="bf-err" data-testid={`billing-${k}-error`}>{errors[k]}</div>}
          </div>
        ))}
      </div>
      <div className="bf-actions">
        <button className="btn primary big" disabled={busy} data-testid="billing-submit">
          {busy ? "Gemmer…" : pending ? "Gem oplysninger" : "Start abonnement"}
        </button>
        <button type="button" className="btn big" onClick={onCancel} data-testid="billing-cancel">Annuller</button>
      </div>
    </form>
  );
}
